import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader2, ThumbsUp } from "lucide-react";
import { getLikes, likePost, unlikePost } from "../../actions/likes.actions";
import ImageProfil from "../Profil/ImageProfil";
import ReactionsModal from "./ReactionsModal";

const Like = ({ post, socket, authorName }) => {
  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const likesData = useSelector((state) => state.likesReducer);
  const userData = useSelector((state) => state.userReducer);
  const usersData = useSelector((state) => state.usersReducer);

  const dispatch = useDispatch();

  // on récupère tous les likes du post
  const likesDuPost = useMemo(
    () => Object.values(likesData).filter((like) => like.postId === post.id),
    [likesData, post.id]
  );

  const [numblikes, setNumbLikes] = useState(likesDuPost.length);

  useEffect(() => {
    setNumbLikes(likesDuPost.length);
  }, [likesDuPost]);

  useEffect(() => {
    const likedByCurrentUser = likesDuPost.find(
      (like) => like.userId === userData.id && like.like !== null
    );
    setLiked(Boolean(likedByCurrentUser));
  }, [likesDuPost, userData]);

  // utilisateurs ayant liké (résolus depuis le store)
  const usersWhoLiked = useMemo(
    () =>
      likesDuPost
        .map((like) => (Array.isArray(usersData) ? usersData.find((u) => u.id === like.userId) : null))
        .filter(Boolean),
    [likesDuPost, usersData]
  );

  const handleLike = async () => {
    setLoading(true);
    if (liked === false) {
      try {
        await dispatch(likePost(post.id, userData.id));
        setLiked(true);
        setNumbLikes(numblikes + 1);
        dispatch(getLikes());
        socket.emit("sendNotification", {
          senderName: userData.name,
          receiverName: authorName,
          receiverId: post.author,
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await dispatch(unlikePost(post.id, userData.id));
        setLiked(false);
        setNumbLikes(numblikes - 1);
        dispatch(getLikes());
      } catch (error) {
        console.log(error);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <div className="footer-left">
        <div
          className={`cardfooter-like ${liked ? "liked" : ""}`}
          onClick={handleLike}
        >
          {loading ? (
            <Loader2 size={17} className="like-spinner" />
          ) : (
            <ThumbsUp size={17} fill={liked ? "currentColor" : "none"} />
          )}
          <span>{numblikes}</span>
        </div>

        <div className="usersLiked" onClick={() => setIsOpen(true)}>
          {usersWhoLiked.slice(0, 3).map((user) => (
            <div className="liker-avatar" key={user.id} title={`${user.firstname} ${user.name}`}>
              <span className="liker-initials">
                {(user.firstname?.[0] || "") + (user.name?.[0] || "")}
              </span>
              <ImageProfil id={user.id} />
            </div>
          ))}
          {numblikes > 3 && (
            <div className="liker-avatar more-likes" title="Voir toutes les réactions">
              +{numblikes - 3}
            </div>
          )}
        </div>
      </div>

      <ReactionsModal open={isOpen} onClose={() => setIsOpen(false)} users={usersWhoLiked} />
    </>
  );
};

export default Like;
